/* eslint-disable prettier/prettier */
import { Button, Typography } from '@mui/material'

import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React from 'react'
import { features } from '../helpers/Constants'
import usePermissions from '../hooks/usePermissions'
import { SURFACE, TEXT, cardSx, pageSx, tint } from '../theme/tokens'

const Container = ({
    children,
    title,
    onPreviousClick,
    onNextClick,
    previousButtonText = 'Back',
    nextButtonText = 'Continue',
    nextDisabled,
    isPanelDisabled,
}) => {
    const hasPermissions = usePermissions()
    const isActionPanelDisabled = () =>
        !hasPermissions(features.CONTAINER_CONTROL_PANEL) ||
        !onNextClick ||
        !onPreviousClick ||
        isPanelDisabled

    return (
        <Box
            sx={{
                ...pageSx,
                p: { xs: 2, md: 3 },
            }}
        >
            <Box
                sx={{
                    ...cardSx,
                    height: 'calc(100vh - 96px)',
                    overflow: 'auto',
                    position: 'relative',
                }}
            >
                {title && (
                    <Box
                        sx={{
                            px: 3,
                            py: 1.75,
                            borderBottom: `1px solid ${SURFACE.border}`,
                            background: SURFACE.subtle,
                        }}
                    >
                        <Typography variant="h6" sx={{ color: TEXT.primary }}>
                            {title}
                        </Typography>
                    </Box>
                )}
                {/* The box ends where BhanzuBot's launcher sits: room to
                    scroll its last content clear of it. */}
                <Box sx={{ p: 3, pb: 11 }}>{children}</Box>
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        borderTop: `1px solid ${SURFACE.border}`,
                        background: tint(SURFACE.card, 0.95),
                        backdropFilter: 'blur(8px)',
                        // Right padding clears BhanzuBot's launcher.
                        p: '12px 88px 12px 20px',
                        display: isActionPanelDisabled() ? 'none' : 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={onPreviousClick}
                        sx={{ width: 90 }}
                    >
                        {previousButtonText}
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onNextClick}
                        disabled={nextDisabled}
                        sx={{ width: 90 }}
                    >
                        {nextButtonText}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

Container.propTypes = {
    children: PropTypes.any,
    title: PropTypes.string,
    onPreviousClick: PropTypes.func,
    onNextClick: PropTypes.func,
    previousButtonText: PropTypes.string,
    nextButtonText: PropTypes.string,
    nextDisabled: PropTypes.bool,
    isPanelDisabled: PropTypes.bool,
}

export default Container
